import useDataLayerEvent from 'js/components/DataLayer/hooks/useDataLayerEvent';

function useOnMouseLeave(dataLayer, handler) {
  return useDataLayerEvent(dataLayer, 'mouseout', handler);
}

export default useOnMouseLeave;
